<template>
  <div class="other-container">
    <div class="card-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="other-wrapper">
        <el-tabs tab-position="left"  v-model="activeName">
            <el-tab-pane label="常见问题" name="question">
                <span slot="label"><i class="el-icon-chat-dot-round"></i> 常见问题</span>
                <div class="question-wrapper">
                    <h2 class="title" style="text-align:center;font-size: 28px;">常见问题</h2>
                    <!-- <p>&nbsp;</p>
                    <p>1.&nbsp;艺考系统的登录网址是什么？</p>
                    <p>答：艺考系统的登录网址是www.zy1dt.cn。</p>
		            <p>&nbsp;</p>
                    <p>2.&nbsp;忘记密码怎么找回？</p>
		            <p>答：请联系客服人员，提供相应的账户信息，如信息无误，客服人员会第一时间帮您找回密码。</p>
		            <p>&nbsp;</p>
		            <p>3.&nbsp;高考分数怎么填？</p>
		            <p>答：在用户中心进行修改相关信息。非志愿填报期间，用户可以输入考生平时的月考、模考或者期末考试成绩，分数修改次数不限；高考成绩公布后，只允许修改一次分数(包含考生文化成绩和专业成绩)。</p>
		            <p>&nbsp;</p>
		            <p>4.&nbsp;怎么查看院校的录取详情？</p>
		            <p>答：点击院校名称或者校徽，进入院校详情页面，选择录取详情，即可查看专业录取数据。</p> -->
		            <template v-if="questionArr.length>0">
                    <div v-for="(item,index) in questionArr" :key="index">
                        <p>&nbsp;</p>
		                <p>{{ item.xh }}.&nbsp;{{ item.ask }}</p>
		                <p>答：{{ item.answer }}</p>      
                    </div>
                    </template>
                    <p>&nbsp;</p>
		            <p>&nbsp;</p>
                </div>
            </el-tab-pane>
            <el-tab-pane label="联系我们" name="contact">
                <!-- <span slot="label"><i class="el-icon-phone-outline"></i> 联系我们</span>
                 <div class="question-wrapper">
                    <h2 class="title">联系我们</h2>
                    <div class="contact-top">
                        <div class="contact-top-left">
                            <p>热线：4000-195-550</p>
                            <p>网址：<a href="www.zy1dt.cn">www.zy1dt.cn</a></p>
                        </div>
                        <div class="contact-top-right">
                            <span>订阅号</span>
                            <img src="./../../assets/images/weixin.jpg" width="100%" alt="微信订阅号号">
                        </div>
                        <div class="contact-top-right">
                            <span>服务号</span>
                            <img src="./../../assets/images/fuwuhao.jpg" width="100%" alt="微信服务号">
                        </div>
                    </div>
                    <div class="contact-QQ">
                        <h3 class="title-QQ">湖南团队联系方式</h3>
                        <table class="contact_table">
                            <tr class="th">
                                <th width="30%">客服</th>
                                <th width="30%">QQ号码</th>
                                <th width="30%">联系QQ</th>
                            </tr>
                            <tr>
                                <td>湖南客服1</td>
                                <td>QQ：2675338431</td>
                                <td><a target="_blank"
                                        href="http://wpa.qq.com/msgrd?v=3&uin=2675338431&site=qq&menu=yes"><img
                                        border="0" src="http://wpa.qq.com/pa?p=2:2675338431:41"
                                        alt="点击这里给我发消息" title="点击这里给我发消息"></a>
                                </td>
                            </tr>
                            <tr>
                                <td>湖南客服2</td>
                                <td>QQ：3484198650</td>
                                <td><a target="_blank"
                                        href="http://wpa.qq.com/msgrd?v=3&uin=3484198650&site=qq&menu=yes"><img
                                        border="0" src="http://wpa.qq.com/pa?p=2:3484198650:41"
                                        alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                            </tr>
                            <tr>
                                <td>湖南客服3</td>
                                <td>QQ：3471332782</td>
                                <td><a target="_blank"
                                        href="http://wpa.qq.com/msgrd?v=3&uin=3471332782&site=qq&menu=yes"><img
                                        border="0" src="http://wpa.qq.com/pa?p=2:3471332782:41"
                                        alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                            </tr>
                            <tr>
                                <td>湖南客服4</td>
                                <td>QQ：226853310</td>
                                <td><a target="_blank"
                                        href="http://wpa.qq.com/msgrd?v=3&uin=226853310&site=qq&menu=yes"><img
                                        border="0" src="http://wpa.qq.com/pa?p=2:226853310:41"
                                        alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <p>QQ群号：湖南高考五群：201492381（美术艺考群）</p>
                        <p> 联系电话：13787139119（陈）(微信同号) </p>
                        <p> 邮箱地址：44394435@qq.com</p>
                    </div>
                </div> -->
                <div class="i_right" style="width:984px;float:none;box-sizing: border-box;">
                   <dl class="r_th" style="display:flex;justify-content:center;
                   align-items:center;margin-right: 13px;margin-bottom: 60px;">
                   <dd class="th">
                   <span style="font-weight:bold;font-size:28px;">联系我们</span>
                   </dd>
                   </dl>
                    <dl class="clear_div r_contact th">
                       <dd>
                           <table width="100%" border="0" cellspacing="0">
                               <tr>
                                   <td width="40%">
                                    <!-- 免费热线：4000-190-550<br> -->
                                    联系电话：0731-89722148&nbsp;&nbsp;&nbsp;&nbsp;19892897119(微信同号)<br>
                                    售前/售后服务邮箱：44394435@qq.com<br>
                                    <!-- 湖南高考金榜通五群：201492381（美术艺考群）<br> -->
                                    网址：
                                       <a href="http://www.zy1dt.com">http://www.zy1dt.com</a><br>
                                    公司地址：湖南省长沙市开福区永通商邸B栋东单元1405室<br>
                                    <div style="margin:10px 0;"></div>
                                    <!-- QQ群号：<br> -->
                                    <!-- 湖南高考金榜通一群：426566477<br> -->
                                    <!-- 湖南高考金榜通二群：275463431<br>
                                    湖南高考金榜通三群：578121753<br>
                                    湖南高考金榜通四群：661758353<br> -->
                                    
                                       <span style="color:#CD2626;font-size: 16px;letter-spacing: 1px">湖南正在招商加盟中，期待您的加入......</span><br>
                                       <!-- 微信公众号：GK金榜志愿通 (欢迎扫一扫)<br>
                                       微信小程序：GK金榜志愿通 (欢迎扫一扫) -->
                                   </td>
                                   <td width="20%" align="center">
                                       <h4 style="color:#EE4000;margin-top: -14px;">GK金榜志愿通</h4>
                                       <img src="../../../assets/ysh/images/weixin.jpg" width="140" height="140">
                                       <h4 style="color: #EE4000">微信公众号</h4>
                                   </td>
                                   <td width="20%" align="center">
                                    <div style="color:black;font-size: 30px;font-weight: bold;margin-top: -14px;">欢迎扫一扫</div>
                                   </td>
                                   <td width="20%" align="center">
                                       <h4 style="color:#EE4000;margin-top:-14px;">金榜志愿通陈天霞</h4>
                                       <!-- <img src="../../assets/images/fuwuhao.jpg" width="140" height="140"> -->
                                       <img src="../../../assets/img/shipinghao_20250429161633.jpg" width="140" height="140">
                                       <h4 style="color:#EE4000">视频号</h4>
                                   </td>
                               </tr>
                           </table>
                           </dd>
                           </dl>
                   <!-- <dl class="r_th">
                       <dd class="th"><h2><strong>售前/售后服务</strong></h2></dd>
                   </dl> -->
                   <!-- <table class="contact_table">
                       <tr class="th">
                           <th width="20%">客服销售</th>
                           <th width="29%">QQ号码</th>
                           <th width="22%">联系QQ</th>
                       </tr>
                       <tr>
                           <td>金榜志愿通-湖南客服1</td>
                           <td>QQ：2675338431</td>
                           <td><a target="_blank"
                                  href="http://wpa.qq.com/msgrd?v=3&uin=2675338431&site=qq&menu=yes"><img
                                   border="0" src="http://wpa.qq.com/pa?p=2:2675338431:41"
                                   alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                       </tr>
                       <tr>
                           <td>金榜志愿通-湖南客服2</td>
                           <td>QQ：3484198650</td>
                           <td><a target="_blank"
                                  href="http://wpa.qq.com/msgrd?v=3&uin=3484198650&site=qq&menu=yes"><img
                                   border="0" src="http://wpa.qq.com/pa?p=2:3484198650:41"
                                   alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                       </tr>
                       <tr>
                           <td>金榜志愿通-湖南客服3</td>
                           <td>QQ：3471332782</td>
                           <td><a target="_blank"
                                  href="http://wpa.qq.com/msgrd?v=3&uin=3471332782&site=qq&menu=yes"><img
                                   border="0" src="http://wpa.qq.com/pa?p=2:3471332782:41"
                                   alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                       </tr>
                       <tr>
                           <td>金榜志愿通-湖南客服4</td>
                           <td>QQ：226853310</td>
                           <td><a target="_blank"
                                  href="http://wpa.qq.com/msgrd?v=3&uin=226853310&site=qq&menu=yes"><img
                                   border="0" src="http://wpa.qq.com/pa?p=2:226853310:41"
                                   alt="点击这里给我发消息" title="点击这里给我发消息"></a></td>
                       </tr>
                   </table> -->
                   <!-- QQ群号：<br> -->
                <!-- 湖南高考金榜通一群：426566477<br> -->
                <!-- 湖南高考金榜通二群：275463431<br>
                湖南高考金榜通三群：578121753<br>
                湖南高考金榜通四群：661758353<br>
                湖南高考金榜通五群：201492381（美术艺考群）<br> -->

                   <!-- <br> 联系电话：0731-89722148&nbsp;&nbsp;&nbsp;&nbsp;13787139119(微信同号)
                   <br> 售前/售后服务邮箱：44394435@qq.com
                   <br> 地址：湖南省长沙市开福区三一大道303号永通商邸B栋东单元1405室
                   <br>
                   <br> -->
                    <!--<dl class="r_th">
                       <dd class="th">
                           <h2>
                               <strong>河南团队联系方式</strong>
                           </h2>
                       </dd>
                   </dl>-->
                    <!-- <dd style="color:#CD2626;font-size: 16px;letter-spacing: 1px">湖南正在招商加盟中，期待您的加入......</dd> -->
                   <!--<dl class="r_th">
                       <dd class="th">
                           <h2>
                               <strong>湖北团队联系方式</strong>
                           </h2>
                       </dd>
                   </dl>-->
                     <!-- <dd style="color:#CD2626;font-size: 16px;letter-spacing: 1px">广东正在招商加盟中，期待您的加入......</dd>
                     <dd style="color:#CD2626;font-size: 16px;letter-spacing: 1px">四川正在招商加盟中，期待您的加入......</dd> -->
                     <!-- <dd style="color:#CD2626;font-size: 16px;letter-spacing: 1px">湖北正在招商加盟中，期待您的加入......</dd> -->
               </div>
            </el-tab-pane>
        </el-tabs>
    </div>
  
  </div>

</template>
<script>
import {getQuestions} from '../../../api/newExam';
export default {
  name: "OtherType",
  data () {
    return {
      activeName:'contact',
      module:{},
      questionArr:[]
    };
  },
  activated() {
    this.activeName = this.$route.query.id;
  },
  methods:{
    // 获取常见问题
    async getQuestion(){
        // const res=await getQuestions();
        const res=await this.module.getQuestions();
        if(res.data.length>0){
            this.questionArr=res.data;
        }
    },
    async getApiIndexMethod(){
      const flag=this.$apiFlag;
      if(flag===1||flag===3){
        this.module=await import("../../../api/newExam");
      }else if(flag===2){
        this.module=await import("../../../api/newExam11");
      }
    },
  },
  async mounted(){
    this.activeName = this.$route.query.id;
    await this.getApiIndexMethod();
    await this.getQuestion();
  }
}
</script>
<style lang="stylus" scoped>
.other-container
    min-width 1200px
    margin 0 auto
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px) 
    .card-top
        width 1100px
        margin 20px auto
    .other-wrapper
        width 1100px
        margin 0 auto
        padding 10px 0
        border-top 1px solid #ccc 
        .question-wrapper
            margin-left 20px
            color #666
            line-height: 2em
            .title,.title-QQ,.about-title
                border-bottom 1px dashed #ccc
                font-size 15px
                font-weight 800
                color #444
            .contact-top
                display flex
                margin 30px auto
            .contact-top-left
                margin-top 30px 
                line-height 2em
                font-size 14px
                color #666  
            .contact-top-right
                width 140px
                margin-left 80px  
                font-size 14px
                text-align center    
                color #EE4000    
            .contact-QQ
                .contact_table
                    width 100%
                    margin 20px 0px
                    border-width 1px
                    border-style solid
                    border-color rgb(204, 228, 245)
                    border-image initial
                    background rgb(255, 255, 255)  
                    th
                        font-size 15px
                        line-height 42px
                        height 42px
                        background rgb(227, 240, 246)
                        border-right 1px solid rgb(204, 228, 245)
                    td
                        text-align center
                        vertical-align middle
                        line-height 2em
                        border-width 1px 1px
                        border-style none solid solid none
                        border-color rgb(204, 228, 245) rgb(204, 228, 245)
                        border-top none
                        border-left none
                        padding 10px 0px   
            .about-content
                margin-top 10px
                font-size 14px
                text-indent 2em   
                line-height 2em   
            .trait
                margin-top 50px
                font-size 14px    
                h2,label 
                    font-size 14px
                    font-weight 600
                    color #555      

</style>
<style scoped>
 p{
    margin-bottom: 0 !important;
 }
 dl.r_th dd{
    margin-bottom: 0 !important;
 }
 a{
    color: #666;
 }
 
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
</style>